/**
 * Checks if the given pathname is a CRM detail page (client or company).
 */
export const isOnCrmPage = (
  pathname: string,
  enableContextBarOtherPage: boolean,
): boolean => {
  if (!enableContextBarOtherPage) {
    return true;
  }
  return (
    pathname.startsWith('/clients/users/details/') ||
    /^\/companies\/[^/]+/.test(pathname)
  );
};
